// MIT License - Copyright (c) 2026 Doug McNall

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { Warhammer40kAliensPlanets } from './AliensConfig';

export const universeWarhammer40k = {
  id: 'warhammer40k',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: Warhammer40kAliensPlanets
};

export default universeWarhammer40k;
